<template>
	<div
		class="d-flex flex-column justify-content-between lap-welcomestep-height"
	>
		<section class="onboarding-top-content invisible-scroll">
			<section class="w-345px">
				<section class="obm-chat-container mt-36px">
					<!-- Stage 1: White bubble — user's selection -->
					<transition name="chat-pop">
						<div v-if="animationStage >= 1" class="d-flex justify-content-end">
							<div class="obm-user-chat-bubble">
								I am a
								<span class="fw-800 underline">{{ selectedTypeLabel }}</span>
							</div>
						</div>
					</transition>

					<!-- Stage 2: Grey bubble 1 -->
					<transition name="chat-pop">
						<div
							v-if="animationStage >= 2"
							class="obm-hire3x-chat-bubble mt-16px position-relative d-flex justify-content-between p-0"
						>
							<span class="p1624-bubble">
								Great! I have so many opportunities for you!
							</span>
							<img
								src="../../../assets/newonboarding/chatbubble1-img.svg"
								class="first-bubble-img-pos"
								alt=""
							/>
						</div>
					</transition>

					<!-- Stage 3: Grey bubble 2 -->
					<transition name="chat-pop">
						<div
							v-if="animationStage >= 3"
							class="obm-hire3x-chat-bubble mt-16px"
						>
							Just a few details to get started.
						</div>
					</transition>
				</section>

				<!-- Stage 4: Fillable form + buttons (single animation) -->
				<transition name="chat-pop">
					<div v-if="animationStage >= 4" ref="formSection">
						<section class="mt-46px">
							<div class="or-divider position-relative w-100">
								<div
									class="fam-inter text-white fw-LM fs-12 ordividerposition"
									style="left: 30%"
								>
									Fill below information
								</div>
							</div>
							<!-- Year of experience — shown only for experienced candidates -->
							<div
								v-if="selectedType === 'experienced'"
								class="mt-36px position-relative"
							>
								<div class="experience-card mt-36px">
									<div class="experience-top">
										<span>Years of Experience*</span>

										<div class="experience-value">
											<input
												class="yof-input"
												type="text"
												inputmode="numeric"
												:value="experience || ''"
												@input="onExperienceInput"
											/>
										</div>
									</div>

									<input
										v-model.number="experience"
										type="range"
										min="0"
										max="99"
										class="experience-slider"
										:style="{
											'--progress': `${(experience / 99) * 100}%`,
										}"
									/>
								</div>
								<div class="mt-16px position-relative" ref="designationWrapper">
									<div class="obm-inputs-mainheads">Current Job Title</div>
									<div class="obm-input-wrapper">
										<input
											class="obm-input"
											type="text"
											v-model="form.designation"
											placeholder="Designation"
											autocomplete="off"
											maxlength="24"
											@input="onDesignationInput"
											@blur="hideDesignationSuggestions"
										/>
									</div>
									<div
										v-if="
											showDesignationSuggestions && filteredDesignations.length
										"
										class="obm-dropdown position-absolute w-100 d-flex flex-column invisible-scroll"
									>
										<div
											v-for="item in filteredDesignations"
											:key="item"
											class="obm-dropdown-option fs-14 fw-R text-white fam-inter"
											@mousedown.prevent="selectDesignationSuggestion(item)"
										>
											{{ item }}
										</div>
									</div>
								</div>
								<div class="mt-16px position-relative" ref="companyWrapper">
									<div class="obm-inputs-mainheads">Most Recent Company</div>
									<div class="obm-input-wrapper">
										<input
											class="obm-input"
											type="text"
											v-model="form.company"
											placeholder="Company Name"
											autocomplete="off"
											maxlength="40"
											@input="onCompanyInput"
											@blur="hideCompanySuggestions"
										/>
									</div>
									<div
										v-if="showCompanySuggestions && companySuggestions.length"
										class="obm-dropdown position-absolute w-100 d-flex flex-column invisible-scroll"
									>
										<div
											v-for="item in companySuggestions"
											:key="item.key"
											class="obm-dropdown-option fs-14 fw-R text-white fam-inter"
											@mousedown.prevent="selectCompany(item)"
										>
											{{ item.label }}
										</div>
									</div>
								</div>
							</div>
							<!-- Domain -->
							<div
								v-if="selectedType != 'experienced'"
								class="mt-36px position-relative pointer"
								ref="domainWrapper"
							>
								<div class="obm-inputs-mainheads">Domain</div>
								<div class="obm-input-wrapper">
									<div
										class="obm-input d-flex align-items-center justify-content-between"
										:class="{ 'domain-placeholder': !form.domain }"
										type="text"
										@click="toggleDropdown('domainWrapper')"
									>
										<span :style="form.domain ? { color: '#fff' } : {}">{{
											form.domain || "Domain"
										}}</span>
										<img
											src="../../../assets/newonboarding/downchevron.svg"
											alt=""
											:style="{
												transform: showDomaindropdown
													? 'rotate(180deg)'
													: 'rotate(0deg)',
												transition: 'transform 0.25s ease',
											}"
										/>
									</div>
								</div>
								<transition name="obm-drop">
									<div
										v-if="showDomaindropdown"
										class="obm-dropdown position-absolute w-100 d-flex flex-column invisible-scroll"
									>
										<div
											v-for="d in domains"
											:key="d"
											class="obm-dropdown-option fs-14 fw-R text-white fam-inter"
											@click.stop="selectDomain(d)"
										>
											{{ d }}
										</div>
									</div>
								</transition>
							</div>

							<!-- College Name -->
							<div
								v-if="selectedType != 'experienced'"
								class="mt-16px position-relative"
								ref="collegeWrapper"
							>
								<div class="obm-inputs-mainheads">College Name</div>
								<div class="obm-input-wrapper">
									<input
										class="obm-input"
										type="text"
										v-model.trim="$v.form.college.$model"
										placeholder="College Name"
										autocomplete="off"
										@input="onCollegeInput"
										@blur="hideCollegeSuggestions"
									/>
								</div>
								<div
									v-if="showCollegeSuggestions && collegeSuggestions.length"
									class="obm-dropdown position-absolute w-100 d-flex flex-column invisible-scroll"
								>
									<div
										v-for="item in collegeSuggestions"
										:key="item.key"
										class="obm-dropdown-option fs-14 fw-R text-white fam-inter"
										@mousedown.prevent="selectCollege(item)"
									>
										{{ item.label }}
									</div>
								</div>
							</div>

							<!-- Passout Month & Year -->
							<div
								v-if="selectedType != 'experienced'"
								class="mt-16px d-flex gap-12px"
							>
								<!-- Passout Month -->
								<div
									class="flex-1 position-relative pointer"
									ref="passoutMonthWrapper"
								>
									<div class="obm-inputs-mainheads">Passout Month</div>
									<div class="obm-input-wrapper">
										<div
											class="obm-input d-flex align-items-center justify-content-between"
											:class="{ 'domain-placeholder': !form.passoutMonth }"
											@click="togglePassoutMonthDropdown"
										>
											<span
												:style="form.passoutMonth ? { color: '#fff' } : {}"
												>{{ form.passoutMonth || "Month" }}</span
											>
											<img
												src="../../../assets/newonboarding/downchevron.svg"
												alt=""
												:style="{
													transform: showPassoutMonthDropdown
														? 'rotate(180deg)'
														: 'rotate(0deg)',
													transition: 'transform 0.25s ease',
												}"
											/>
										</div>
									</div>
									<transition name="obm-drop">
										<div
											v-if="showPassoutMonthDropdown"
											class="obm-dropdown position-absolute w-100 d-flex flex-column invisible-scroll"
										>
											<div
												v-for="m in months"
												:key="m"
												class="obm-dropdown-option fs-14 fw-R text-white fam-inter"
												@click.stop="selectPassoutMonth(m)"
											>
												{{ m }}
											</div>
										</div>
									</transition>
								</div>

								<!-- Passout Year -->
								<div
									class="flex-1 position-relative pointer"
									ref="passoutYearWrapper"
								>
									<div class="obm-inputs-mainheads">Passout Year</div>
									<div class="obm-input-wrapper">
										<div
											class="obm-input d-flex align-items-center justify-content-between"
											:class="{ 'domain-placeholder': !form.passoutYear }"
											@click="togglePassoutYearDropdown"
										>
											<span
												:style="form.passoutYear ? { color: '#fff' } : {}"
												>{{ form.passoutYear || "Year" }}</span
											>
											<img
												src="../../../assets/newonboarding/downchevron.svg"
												alt=""
												:style="{
													transform: showPassoutYearDropdown
														? 'rotate(180deg)'
														: 'rotate(0deg)',
													transition: 'transform 0.25s ease',
												}"
											/>
										</div>
									</div>
									<transition name="obm-drop">
										<div
											v-if="showPassoutYearDropdown"
											class="obm-dropdown position-absolute w-100 d-flex flex-column invisible-scroll"
										>
											<div
												v-for="y in passoutYears"
												:key="y"
												class="obm-dropdown-option fs-14 fw-R text-white fam-inter"
												@click.stop="selectPassoutYear(y)"
											>
												{{ y }}
											</div>
										</div>
									</transition>
								</div>
							</div>
						</section>
					</div>
				</transition>
			</section>
		</section>
		<section
			class="onboarding-top-content onboarding-bottom-content mob-pt-25px"
		>
			<section class="w-345px">
				<!-- Actions -->
				<transition name="chat-pop">
					<div
						v-if="buttonsVisible"
						class="d-flex align-items-center justify-content-between gap-12px mt-30px mt-mob-0"
					>
						<button class="obm-back-btn" @click="$emit('back')">Go back</button>
						<button
							class="skybluebtn w-141px fam-inter text-white fs-14 text-center"
							style="height: 49px"
							:disabled="$v.$invalid || isSubmitting"
							:style="{
								opacity: $v.$invalid ? 0.4 : 1,
								cursor: $v.$invalid ? 'not-allowed' : 'pointer',
							}"
							@click="handleContinue"
						>
							Continue
						</button>
					</div>
				</transition>
			</section>
		</section>
	</div>
</template>

<script>
import {
	postCandidateOnboard,
	getSuggestionCollege,
	getSuggestionCompany,
	getCandidateOnboard,
} from "@/utils/apiFunctions";
import { required, minLength } from "vuelidate/lib/validators";
export default {
	emits: ["back", "next"],

	props: {
		selectedType: {
			type: String,
			default: "Fresher",
		},
		skipDetailsAnimation: {
			type: Boolean,
			default: false,
		},
		// Prefilled data passed from parent (fetched during Goals → Back)
		prefillData: {
			type: Object,
			default: null,
		},
	},

	data() {
		return {
			showDomaindropdown: false,
			_dropdownScroller: null,
			_dropdownSavedScrollTop: null,
			animationStage: 0,
			buttonsVisible: false,
			isSubmitting: false,
			showPassoutMonthDropdown: false,
			showPassoutYearDropdown: false,
			form: {
				designation: "",
				domain: "",
				company: "",
				college: "",
				passoutMonth: "",
				passoutYear: "",
			},
			months: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec",
			],
			domains: [
				"Technology",
				"Design",
				"Marketing",
				"Finance",
				"Operations",
				"HR",
			],
			experience: 0,
			// Designation autocomplete
			designationList: [
				"Software Engineer",
				"Software Developer",
				"Full Stack Developer",
				"Frontend Developer",
				"Backend Developer",
				"Senior Software Engr",
				"Tech Lead",
				"DevOps Engineer",
				"Cloud Engineer",
				"Data Scientist",
				"Data Engineer",
				"Machine Learning Engr",
				"AI Engineer",
				"QA Engineer",
				"Automation Test Engr",
				"UI/UX Designer",
				"Business Analyst",
				"Product Manager",
				"Project Manager",
			],
			showDesignationSuggestions: false,
			// College autocomplete
			collegeSuggestions: [],
			showCollegeSuggestions: false,
			// Company autocomplete
			companySuggestions: [],
			showCompanySuggestions: false,
			companySearchTimeout: null,
			collegeSearchTimeout: null,
			currentPage: 0,
			passoutYears: (() => {
				const cur = new Date().getFullYear();
				const years = [];
				for (let y = 1970; y <= cur + 5; y++) years.push(String(y));
				return years;
			})(),
		};
	},

	computed: {
		selectedTypeLabel() {
			if (!this.selectedType) return "Fresher";
			return (
				this.selectedType.charAt(0).toUpperCase() + this.selectedType.slice(1)
			);
		},
		filteredDesignations() {
			const query = (this.form.designation || "").trim().toLowerCase();
			if (!query) return this.designationList;
			return this.designationList.filter((d) =>
				d.toLowerCase().includes(query)
			);
		},
	},

	validations() {
		if (this.selectedType === "experienced") {
			return {
				experience: { required },
				form: {
					designation: { required },
					company: { required },
				},
			};
		}
		return {
			form: {
				domain: { required },
				college: { required },
				passoutMonth: { required },
				passoutYear: { required },
			},
		};
	},
	async created() {
		if (this.skipDetailsAnimation) {
			this.animationStage = 5;
			this.buttonsVisible = true;
			return;
		}

		await this.playAnimation();
	},

	mounted() {
		// Apply prefill data if provided by parent (passed from Goals → Back API response).
		// Do NOT call the API here — that would fire on every render including
		// normal forward navigation from Welcome.
		if (this.prefillData) {
			this.applyPrefillData(this.prefillData);
		}
		document.addEventListener("click", this.closeDropdownOnClickOutside);
	},

	beforeDestroy() {
		document.removeEventListener("click", this.closeDropdownOnClickOutside);
	},

	methods: {
		wait(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},

		onExperienceInput(e) {
			const cleaned = e.target.value.replace(/\D/g, "").slice(0, 2);
			e.target.value = cleaned;
			this.experience = cleaned === "" ? 0 : Number(cleaned);
		},

		// Apply a data object (from API response) into the form fields.
		applyPrefillData(data) {
			if (!data) return;
			if (data.domain) this.form.domain = data.domain;
			if (data.collegeName) this.form.college = data.collegeName;
			if (data.passoutYear) {
				const parts = String(data.passoutYear).split("-");
				this.form.passoutYear = parts[0];
				if (parts[1]) {
					const monthIndex = parseInt(parts[1], 10) - 1;
					this.form.passoutMonth = this.months[monthIndex] || "";
				}
			}
			if (data.designation) this.form.designation = data.designation;
			if (data.companyName) this.form.company = data.companyName;
			if (data.totalYearsOfExp !== undefined)
				this.experience = data.totalYearsOfExp;
		},

		// ── Dropdown scroll helpers ──────────────────────────────────────────
		_findScroller(el) {
			let node = el.parentElement;
			while (node && node !== document.documentElement) {
				const s = window.getComputedStyle(node);
				if (
					(s.overflowY === "auto" ||
						s.overflowY === "scroll" ||
						s.overflowY === "overlay") &&
					node.scrollHeight > node.clientHeight
				)
					return node;
				node = node.parentElement;
			}
			return null;
		},

		_animateScroll(scroller, from, to, duration = 350) {
			const ease = (t) => t * t * (3 - 2 * t);
			let start = null;
			const step = (ts) => {
				if (!start) start = ts;
				const p = Math.min((ts - start) / duration, 1);
				scroller.scrollTop = from + (to - from) * ease(p);
				if (p < 1) requestAnimationFrame(step);
			};
			requestAnimationFrame(step);
		},

		closeDropdownOnClickOutside(event) {
			const refs = [
				this.$refs.domainWrapper,
				this.$refs.designationWrapper,
				this.$refs.passoutMonthWrapper,
				this.$refs.passoutYearWrapper,
			].filter(Boolean);
			const clickedInside = refs.some((r) => r.contains(event.target));
			if (clickedInside) return;
			const wasOpen =
				this.showDomaindropdown ||
				this.showPassoutMonthDropdown ||
				this.showPassoutYearDropdown;
			this.showDomaindropdown = false;
			this.showPassoutMonthDropdown = false;
			this.showPassoutYearDropdown = false;
			if (
				wasOpen &&
				this._dropdownScroller !== null &&
				this._dropdownSavedScrollTop !== null
			) {
				this._animateScroll(
					this._dropdownScroller,
					this._dropdownScroller.scrollTop,
					this._dropdownSavedScrollTop
				);
			}
			this._dropdownScroller = null;
			this._dropdownSavedScrollTop = null;
		},

		toggleDropdown(refName) {
			if (this.showDomaindropdown) {
				// Close — restore original scroll
				this.showDomaindropdown = false;
				if (
					this._dropdownScroller !== null &&
					this._dropdownSavedScrollTop !== null
				) {
					this._animateScroll(
						this._dropdownScroller,
						this._dropdownScroller.scrollTop,
						this._dropdownSavedScrollTop
					);
				}
				this._dropdownScroller = null;
				this._dropdownSavedScrollTop = null;
			} else {
				// Open — save position, show dropdown, then scroll into view
				this.showDomaindropdown = true;
				this.$nextTick(() => {
					const wrapper = this.$refs[refName];
					if (!wrapper) return;
					const scroller = this._findScroller(wrapper);
					if (!scroller) return;
					this._dropdownScroller = scroller;
					this._dropdownSavedScrollTop = scroller.scrollTop;
					// Find the dropdown element (last child of wrapper)
					const dropdown = wrapper.querySelector(".obm-dropdown");
					if (!dropdown) return;
					const dropBottom = dropdown.getBoundingClientRect().bottom;
					const scrollerBottom = scroller.getBoundingClientRect().bottom;
					const overflow = dropBottom - scrollerBottom;
					if (overflow > 0) {
						this._animateScroll(
							scroller,
							scroller.scrollTop,
							scroller.scrollTop + overflow + 16
						);
					}
				});
			}
		},

		selectDomain(domain) {
			this.form.domain = domain;
			this.showDomaindropdown = false;
			if (
				this._dropdownScroller !== null &&
				this._dropdownSavedScrollTop !== null
			) {
				this._animateScroll(
					this._dropdownScroller,
					this._dropdownScroller.scrollTop,
					this._dropdownSavedScrollTop
				);
			}
			this._dropdownScroller = null;
			this._dropdownSavedScrollTop = null;
		},

		selectDesignation(designation) {
			this.form.designation = designation;
			this.showDomaindropdown = false;
			if (
				this._dropdownScroller !== null &&
				this._dropdownSavedScrollTop !== null
			) {
				this._animateScroll(
					this._dropdownScroller,
					this._dropdownScroller.scrollTop,
					this._dropdownSavedScrollTop
				);
			}
			this._dropdownScroller = null;
			this._dropdownSavedScrollTop = null;
		},

		// Designation autocomplete
		onDesignationInput() {
			this.showDesignationSuggestions = this.form.designation.trim().length > 0;
			if (this.showDesignationSuggestions) {
				this._scrollDesignationIntoView();
			}
		},

		_scrollDesignationIntoView() {
			this.$nextTick(() => {
				const wrapper = this.$refs.designationWrapper;
				if (!wrapper) return;
				const scroller = this._findScroller(wrapper);
				if (!scroller) return;
				const dropdown = wrapper.querySelector(".obm-dropdown");
				if (!dropdown) return;
				const dropBottom = dropdown.getBoundingClientRect().bottom;
				const scrollerBottom = scroller.getBoundingClientRect().bottom;
				const overflow = dropBottom - scrollerBottom;
				if (overflow > 0) {
					this._animateScroll(
						scroller,
						scroller.scrollTop,
						scroller.scrollTop + overflow + 16
					);
				}
			});
		},
		hideDesignationSuggestions() {
			setTimeout(() => {
				this.showDesignationSuggestions = false;
			}, 150);
		},
		selectDesignationSuggestion(item) {
			this.form.designation = item;
			this.showDesignationSuggestions = false;
		},

		// Scroll the dropdown list so the selected (or current) item appears at top
		_scrollDropdownToActive(dropdown, refName) {
			const now = new Date();
			let activeText = "";
			if (refName === "passoutMonthWrapper") {
				activeText = this.form.passoutMonth || this.months[now.getMonth()];
			} else if (refName === "passoutYearWrapper") {
				activeText = this.form.passoutYear || String(now.getFullYear());
			}
			if (!activeText) return;
			const items = dropdown.querySelectorAll(".obm-dropdown-option");
			let target = null;
			for (const item of items) {
				if (item.textContent.trim() === activeText) {
					target = item;
					break;
				}
			}
			if (target) {
				dropdown.scrollTop = target.offsetTop;
			}
		},

		// ── Generic passout dropdown open helper ────────────────────────────
		_openPassoutDropdown(flagKey, refName) {
			// Close any other open dropdown and restore scroll first
			const wasOpen =
				this.showDomaindropdown ||
				this.showPassoutMonthDropdown ||
				this.showPassoutYearDropdown;
			if (
				wasOpen &&
				this._dropdownScroller !== null &&
				this._dropdownSavedScrollTop !== null
			) {
				this._animateScroll(
					this._dropdownScroller,
					this._dropdownScroller.scrollTop,
					this._dropdownSavedScrollTop
				);
				this._dropdownScroller = null;
				this._dropdownSavedScrollTop = null;
			}
			this.showDomaindropdown = false;
			this.showPassoutMonthDropdown = false;
			this.showPassoutYearDropdown = false;

			// Open the requested dropdown
			this[flagKey] = true;
			this.$nextTick(() => {
				const wrapper = this.$refs[refName];
				if (!wrapper) return;
				const scroller = this._findScroller(wrapper);
				if (scroller) {
					this._dropdownScroller = scroller;
					this._dropdownSavedScrollTop = scroller.scrollTop;
					const dropdown = wrapper.querySelector(".obm-dropdown");
					if (dropdown) {
						const dropBottom = dropdown.getBoundingClientRect().bottom;
						const scrollerBottom = scroller.getBoundingClientRect().bottom;
						const overflow = dropBottom - scrollerBottom;
						if (overflow > 0) {
							this._animateScroll(
								scroller,
								scroller.scrollTop,
								scroller.scrollTop + overflow + 16
							);
						}
					}
				}

				// Always scroll internal dropdown list to active (current month/year)
				const scrollActive = () => {
					const freshWrapper = this.$refs[refName];
					if (!freshWrapper) return;
					const freshDropdown = freshWrapper.querySelector(".obm-dropdown");
					if (!freshDropdown) return;
					this._scrollDropdownToActive(freshDropdown, refName);
				};

				scrollActive();
				setTimeout(scrollActive, 50);
				setTimeout(scrollActive, 300);
			});
		},

		_closePassoutDropdown(flagKey) {
			this[flagKey] = false;
			if (
				this._dropdownScroller !== null &&
				this._dropdownSavedScrollTop !== null
			) {
				this._animateScroll(
					this._dropdownScroller,
					this._dropdownScroller.scrollTop,
					this._dropdownSavedScrollTop
				);
			}
			this._dropdownScroller = null;
			this._dropdownSavedScrollTop = null;
		},

		// Passout Month dropdown
		togglePassoutMonthDropdown() {
			if (this.showPassoutMonthDropdown) {
				this._closePassoutDropdown("showPassoutMonthDropdown");
			} else {
				this._openPassoutDropdown(
					"showPassoutMonthDropdown",
					"passoutMonthWrapper"
				);
			}
		},
		selectPassoutMonth(month) {
			this.form.passoutMonth = month;
			this._closePassoutDropdown("showPassoutMonthDropdown");
		},

		// Passout Year dropdown
		togglePassoutYearDropdown() {
			if (this.showPassoutYearDropdown) {
				this._closePassoutDropdown("showPassoutYearDropdown");
			} else {
				this._openPassoutDropdown(
					"showPassoutYearDropdown",
					"passoutYearWrapper"
				);
			}
		},
		selectPassoutYear(year) {
			this.form.passoutYear = year;
			this._closePassoutDropdown("showPassoutYearDropdown");
		},

		async handleContinue() {
			this.$v.$touch();
			if (this.$v.$invalid || this.isSubmitting) return;
			this.isSubmitting = true;
			console.log("inside fun");
			try {
				const payload = {
					step: "skills",
					experienceLevel:
						this.selectedType === "experienced"
							? "intermediate"
							: this.selectedType?.toLowerCase(),
					...(this.selectedType === "experienced"
						? {
								totalYearsOfExp: this.experience,
								designation: this.form.designation,
								companyName: this.form.company,
						  }
						: {
								domain: this.form.domain,
								collegeName: this.form.college,
								passoutYear: `${this.form.passoutYear}-${String(
									this.months.indexOf(this.form.passoutMonth) + 1
								).padStart(2, "0")}`,
						  }),
				};
				console.log("wdwed", payload);
				const response = await postCandidateOnboard(payload);
				console.log("postCandidateOnboard response:", response);
				console.log("postCandidateOnboard response.data:", response?.data);
			} catch (err) {
				console.error("Onboarding error:", err);
			} finally {
				this.isSubmitting = false;
			}
			this.$emit("next");
		},

		async playAnimation() {
			await this.wait(300);
			this.animationStage = 1;

			await this.wait(600);
			this.animationStage = 2;

			await this.wait(900);
			this.animationStage = 3;

			await this.wait(1000);
			this.animationStage = 4;
			await this.$nextTick();
			this.smoothScrollToForm();
			await this.wait(400);
			this.buttonsVisible = true;
		},
		smoothScrollToForm() {
			const el = this.$refs.formSection;
			if (!el) return;

			// Walk up to find the scrollable parent
			let scroller = el.parentElement;
			while (scroller && scroller !== document.documentElement) {
				const style = window.getComputedStyle(scroller);
				if (
					(style.overflowY === "auto" ||
						style.overflowY === "scroll" ||
						style.overflowY === "overlay") &&
					scroller.scrollHeight > scroller.clientHeight
				)
					break;
				scroller = scroller.parentElement;
			}
			if (!scroller || scroller === document.documentElement) return;

			const startY = scroller.scrollTop;
			const targetY =
				startY +
				el.getBoundingClientRect().top -
				scroller.getBoundingClientRect().top -
				24;
			const distance = targetY - startY;

			let startTime = null;

			const duration = 1200;

			const ease = (t) => {
				return t * t * (3 - 2 * t);
			}; // ease-out cubic

			const step = (ts) => {
				if (!startTime) startTime = ts;
				const p = Math.min((ts - startTime) / duration, 1);
				scroller.scrollTop = startY + distance * ease(p);
				if (p < 1) requestAnimationFrame(step);
			};

			requestAnimationFrame(step);
		},

		// College autocomplete
		onCollegeInput() {
			clearTimeout(this.collegeSearchTimeout);
			const query = this.form.college.trim();
			if (!query) {
				this.collegeSuggestions = [];
				this.showCollegeSuggestions = false;
				return;
			}
			this.collegeSearchTimeout = setTimeout(async () => {
				this.currentPage = 0;
				await this.getCollegeSuggestion();
				this._scrollCollegeIntoView();
			}, 300);
		},

		_scrollCollegeIntoView() {
			this.$nextTick(() => {
				const wrapper = this.$refs.collegeWrapper;
				if (!wrapper) return;
				const scroller = this._findScroller(wrapper);
				if (!scroller) return;
				const dropdown = wrapper.querySelector(".obm-dropdown");
				if (!dropdown) return;
				const dropBottom = dropdown.getBoundingClientRect().bottom;
				const scrollerBottom = scroller.getBoundingClientRect().bottom;
				const overflow = dropBottom - scrollerBottom;
				if (overflow > 0) {
					this._animateScroll(
						scroller,
						scroller.scrollTop,
						scroller.scrollTop + overflow + 16
					);
				}
			});
		},

		selectCollege(item) {
			this.form.college = item.label;
			this.collegeSuggestions = [];
			this.showCollegeSuggestions = false;
		},

		hideCollegeSuggestions() {
			setTimeout(() => {
				this.showCollegeSuggestions = false;
			}, 150);
		},

		// Company autocomplete
		onCompanyInput() {
			clearTimeout(this.companySearchTimeout);
			const query = this.form.company.trim();
			if (!query) {
				this.companySuggestions = [];
				this.showCompanySuggestions = false;
				return;
			}
			this.companySearchTimeout = setTimeout(async () => {
				await this.getCompanySuggestion();
				this._scrollCompanyIntoView();
			}, 300);
		},

		_scrollCompanyIntoView() {
			this.$nextTick(() => {
				const wrapper = this.$refs.companyWrapper;
				if (!wrapper) return;
				const scroller = this._findScroller(wrapper);
				if (!scroller) return;
				const dropdown = wrapper.querySelector(".obm-dropdown");
				if (!dropdown) return;
				const dropBottom = dropdown.getBoundingClientRect().bottom;
				const scrollerBottom = scroller.getBoundingClientRect().bottom;
				const overflow = dropBottom - scrollerBottom;
				if (overflow > 0) {
					this._animateScroll(
						scroller,
						scroller.scrollTop,
						scroller.scrollTop + overflow + 16
					);
				}
			});
		},

		selectCompany(item) {
			this.form.company = item.label;
			this.companySuggestions = [];
			this.showCompanySuggestions = false;
		},

		hideCompanySuggestions() {
			setTimeout(() => {
				this.showCompanySuggestions = false;
			}, 150);
		},

		async getCompanySuggestion() {
			try {
				const payload = {
					companyName: this.form.company.trim(),
					page: 0,
				};
				const resp = await getSuggestionCompany(payload);
				if (resp.status === 200) {
					const responseData = resp.data.data.response;
					const mapItem = (item) => ({
						key: item.value?.value ?? item.value,
						label: item.text?.text ?? item.text,
					});
					this.companySuggestions = responseData.map(mapItem);
					this.showCompanySuggestions = this.companySuggestions.length > 0;
				} else {
					console.error("Company API error: ", resp.status);
				}
			} catch (error) {
				console.error("Error fetching company suggestions: ", error);
			}
		},

		async getCollegeSuggestion() {
			try {
				const payload = {
					institute: this.form.college.trim(),
					page: this.currentPage,
				};

				const resp = await getSuggestionCollege(payload);

				if (resp.status === 200) {
					const responseData = resp.data.data.response;
					const isFirstPage = this.currentPage === 0;

					const mapItem = (item) => ({
						key: item.value?.value ?? item.value,
						label: item.text?.text ?? item.text,
					});

					if (isFirstPage) {
						this.collegeSuggestions = responseData.map(mapItem);
					} else {
						this.collegeSuggestions = [
							...this.collegeSuggestions,
							...responseData.map(mapItem),
						];
					}

					this.showCollegeSuggestions = this.collegeSuggestions.length > 0;
				} else {
					console.error("College API error: ", resp.status);
				}
			} catch (error) {
				console.error("Error fetching college suggestions: ", error);
			}
		},
	},
};
</script>

<style scoped>
/* ── White bubble (user's reply) ── */
.obm-user-chat-bubble {
	padding: 16px;
	background: #ffffff;
	border: 0.5px solid rgba(239, 239, 239, 0.14);
	border-radius: 40px 0px 40px 40px;
	font-family: "Manrope", sans-serif;
	font-weight: 600;
	font-size: 16px;
	color: #000000;
}

.first-bubble-img-pos {
	z-index: 2000;
}

/* ── Fillable label ── */
.fillable-label {
	font-family: "Manrope", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.5);
	margin: 0;
	text-align: center;
}

.obm-input-wrapper {
	position: relative;
	width: 100%;
	height: 48px;
	border-radius: 32px;

	background: rgba(255, 255, 255, 0.2);

	backdrop-filter: blur(25px) saturate(150%);
	-webkit-backdrop-filter: blur(25px) saturate(150%);

	overflow: hidden;

	box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.12),
		inset 0 -1px 2px rgba(0, 0, 0, 0.1);
}

.obm-input-wrapper::before {
	content: "";
	position: absolute;
	inset: 0;

	border-radius: inherit;
	padding: 1px;

	background: linear-gradient(
		135deg,
		rgba(255, 255, 255, 0.35) 0%,
		rgba(255, 255, 255, 0) 32%,
		rgba(255, 255, 255, 0.2) 68%,
		rgba(255, 255, 255, 0.35) 100%
	);

	-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);

	-webkit-mask-composite: xor;
	mask-composite: exclude;

	pointer-events: none;
	z-index: 2;
}

.obm-input {
	position: relative;
	z-index: 1;
	width: 100%;
	height: 100%;
	padding: 16px 24px;
	background: transparent;
	border: none;
	outline: none;
	color: #fff;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 600;
}

.obm-input-placeholder {
	position: absolute;
	left: 25px;
	top: 65%;
	transform: translateY(-50%);
	font-family: "Inter", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #c1c1c1;
}

.obm-input::placeholder,
.domain-placeholder {
	font-family: "Inter", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #c1c1c1;
}

.obm-input option {
	background: #2a303c;
	color: #fff;
}

/* ── Buttons ── */
.obm-back-btn {
	padding: 12px 24px;
	width: 141.82px;
	background: rgba(0, 0, 0, 0.004);
	border: 0.5px solid #4a7eff;
	border-radius: 40px;
	font-family: "Inter", sans-serif;
	font-weight: 600;
	font-size: 14px;
	color: #ffffff;
	height: 49px;
	cursor: pointer;
}
.skybluebtn {
	padding: 12px 24px;
	background: #4a7eff;
	border: 0.5px solid rgba(239, 239, 239, 0.14);
	border-radius: 40px;
}
/* ── Animation ── */
.chat-pop-enter-active {
	transition: opacity 0.35s ease, transform 0.35s ease;
}

.chat-pop-leave-active {
	transition: opacity 0.2s ease;
}

.chat-pop-enter,
.chat-pop-leave-to {
	opacity: 0;
	transform: translateY(12px) scale(0.96);
}
.obm-inputs-mainheads {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	color: #efefef;
	margin-bottom: 4px;
}
.or-divider {
	width: 75%;
	height: 0px;
	border: 1px solid #cbd5e1;
	margin-top: 36px;
	margin-bottom: 36px;
}
.ordividerposition {
	position: absolute;
	left: 45%;
	top: -10px;
	padding: 0 8px;
	background: rgb(49 55 66 / 90%);
	z-index: 1050;
	overflow: hidden;
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
}

.w-141px {
	width: 141.82px;
}
.obm-dropdown-option {
	cursor: pointer;
}

.obm-dropdown-option:hover {
	opacity: 0.75;
}

.obm-dropdown {
	padding: 16px 24px;
	gap: 15px;
	min-height: auto;
	max-height: 160px;
	z-index: 2000;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	box-sizing: border-box;
	background: #484f5c;
	border: 1px solid rgba(226, 232, 240, 0.1);
	box-shadow: 0px 96px 38px rgba(59, 59, 59, 0.01),
		0px 54px 32px rgba(59, 59, 59, 0.05), 0px 24px 24px rgba(59, 59, 59, 0.09),
		0px 6px 13px rgba(59, 59, 59, 0.1);
	backdrop-filter: blur(25px);
	margin-top: 3px;
	border-radius: 32px;
}

/* ── Dropdown open / close animation ── */
.obm-drop-enter-active {
	transition: opacity 0.25s ease, transform 0.25s ease;
}
.obm-drop-leave-active {
	transition: opacity 0.22s ease, transform 0.22s ease;
}
.obm-drop-enter,
.obm-drop-leave-to {
	opacity: 0;
	transform: translateY(-6px) scale(0.97);
}

.experience-card {
	position: relative;
	width: 100%;
	padding: 16px 24px;
	border-radius: 32px;
	background: rgba(255, 255, 255, 0.2);
	backdrop-filter: blur(25px) saturate(150%);
	-webkit-backdrop-filter: blur(25px) saturate(150%);
	overflow: hidden;
	box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.12),
		inset 0 -1px 2px rgba(0, 0, 0, 0.1);
}
.experience-card::before {
	content: "";
	position: absolute;
	inset: 0;
	border-radius: inherit;
	padding: 1px;
	background: linear-gradient(
		135deg,
		rgba(255, 255, 255, 0.35) 0%,
		rgba(255, 255, 255, 0) 32%,
		rgba(255, 255, 255, 0.2) 68%,
		rgba(255, 255, 255, 0.35) 100%
	);
	-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
	-webkit-mask-composite: xor;
	mask-composite: exclude;
	pointer-events: none;
	z-index: 2;
}
.experience-top {
	position: relative;
	z-index: 3;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.experience-top span {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	color: #efefef;
}
.experience-value {
	width: 78px;
	height: 37px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 20px;
	background: rgba(255, 255, 255, 0.03);
	border: 1px solid rgba(255, 255, 255, 0.28);
}
.experience-slider {
	--progress: 35%;
	position: relative;
	z-index: 3;
	width: 100%;
	height: 4px;
	appearance: none;
	-webkit-appearance: none;

	background: linear-gradient(
		to right,
		#ffffff var(--progress),
		rgba(255, 255, 255, 0.2) var(--progress)
	);

	border-radius: 10px;

	outline: none;

	box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.35),
		0 1px 2px rgba(0, 0, 0, 0.12);
}
.experience-slider::-webkit-slider-thumb {
	appearance: none;
	-webkit-appearance: none;

	width: 24px;
	height: 25px;

	border-radius: 50%;

	background: radial-gradient(
		circle at 35% 30%,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.92) 45%,
		rgba(235, 235, 235, 0.85) 100%
	);

	border: 1px solid rgba(255, 255, 255, 0.65);

	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.18),
		inset 0 1px 1px rgba(255, 255, 255, 0.8);

	cursor: pointer;
}
.experience-slider::-moz-range-thumb {
	width: 24px;
	height: 25px;

	border-radius: 50%;

	background: radial-gradient(
		circle at 35% 30%,
		rgba(255, 255, 255, 1) 0%,
		rgba(255, 255, 255, 0.92) 45%,
		rgba(235, 235, 235, 0.85) 100%
	);

	border: 1px solid rgba(255, 255, 255, 0.65);

	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.18),
		inset 0 1px 1px rgba(255, 255, 255, 0.8);
}
.experience-card input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}
.yof-input {
	background: transparent;
	border: unset;
	width: 100%;
	text-align: center;
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	color: #ffffff;
}
</style>
